import {createFileRoute} from '@tanstack/react-router';
import {PaymentCallbackTimeoutPage} from 'features/shared/payment/pages/PaymentCallbackTimeoutPage';

export const Route = createFileRoute(
  '/_protected/bill-payment/$billId/callback/_statuses/timeout',
)({
  component: () => (
    <PaymentCallbackTimeoutPage
      pageId="bill_payment_timeout"
      navigateTo="/home/statements"
    />
  ),
});
